"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionsPerPage = void 0;
var TransactionsPerPage = {
  RECENT: 5
};
exports.TransactionsPerPage = TransactionsPerPage;